import styled from 'styled-components';

export const Title = styled.h4`
  font-family: ${({ theme }) => theme.fonts.openSans};
  font-weight: 400;
  font-size: 1.25rem;
`;

export const BodyContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 60% 40%;
  align-items: start;
  padding-bottom: 1em;
`;

export const ItemDescription = styled.div`
  font-family: ${({ theme }) => theme.fonts.workSans};
  font-size: 1rem;
  padding-right: 1em;
`;

export const ItemOptions = styled.div`
  display: flex;
  gap: 1em;
`;
